var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheck32 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3137C0 9.19198 0.842852 7.15715 2.34314 5.65686L5.65685 2.34315C7.15715 0.842855 9.19198 0 11.3137 0H24C28.4183 0 32 3.58172 32 8V20.6863C32 22.808 31.1571 24.8429 29.6569 26.3431L26.3431 29.6569C24.8429 31.1571 22.808 32 20.6863 32H8C3.58172 32 0 28.4183 0 24V11.3137Z",
    fill: "#00BFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93692 31.9998C5.00208 31.9771 2.44349 30.3741 1.07012 27.9998H10.3431C11.404 27.9998 12.4214 27.5783 13.1716 26.8282L14.8284 25.1713C15.5786 24.4212 16.596 23.9998 17.6569 23.9998H23C25.2091 23.9998 27 25.7906 27 27.9998V29L26.3431 29.6569C24.8576 31.1424 22.848 31.9834 20.7488 31.9998L7.93692 31.9998Z",
    fill: "#13ECC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 8.38C23.75 8.64666 23.6567 8.87333 23.47 9.06L16.23 16.3L14.87 17.66C14.6833 17.8467 14.4567 17.94 14.19 17.94C13.9233 17.94 13.6967 17.8467 13.51 17.66L12.15 16.3L8.53 12.68C8.34333 12.4933 8.25 12.2667 8.25 12C8.25 11.7333 8.34333 11.5067 8.53 11.32L9.89 9.96C10.0767 9.77333 10.3033 9.68 10.57 9.68C10.8367 9.68 11.0633 9.77333 11.25 9.96L14.19 12.91L20.75 6.34C20.9367 6.15333 21.1633 6.06 21.43 6.06C21.6967 6.06 21.9233 6.15333 22.11 6.34L23.47 7.7C23.6567 7.88666 23.75 8.11333 23.75 8.38Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheck32);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_check_32.8c6c03eedb88739b4efe0dbd47d489ae.svg";